import { Dispatch, SetStateAction, createContext } from 'react'
import { IMediaFileWithId, IMediaFiles } from 'src/types'

interface IMediaInputContext {
  media?: IMediaFiles
  setMedia: (value: IMediaFiles) => void
  webcamKey: number
  setWebcamKey: Dispatch<SetStateAction<number>>
  inputName: string
  image: IMediaFileWithId | null
  setImage: Dispatch<SetStateAction<IMediaFileWithId | null>>
  handleDelete: (field: string, value: any) => void
}

export const MediaInputContext = createContext<IMediaInputContext>({} as IMediaInputContext)
